import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../../app.json";
import { ReadData } from "../../../../providers/Patient.Provider";
import auth from "../../../../providers/Auth.Provider";
import LoadingSpinner from "../../../../partials/loading";
import { LIST, CREATE, SET_TAKEN } from "../../../../queries/patient-activity.query";
import { useQuery, useMutation } from "@apollo/react-hooks";
import PatientActivityListing from "./Listing";
import NewActivity from "./NewActivity";
import { toast } from "react-toastify";
import { CleanMessage } from "../../../../util/app";
import { EventEmitter } from "../../../../event/EventEmitter";
import { EVENT_TARGET, ACTION_TYPE } from "../../../../event/model";
import { sendNotification } from "../../../../sockette";
import FabButton from "../../../../partials/Buttons/FabButton";

function PatientActivity() {
    const [newItem, setNewItem] = useState(false);
    const [activeItem, setActiveItem] = useState(null);
    const [setItem] = useState(null);

    const patient = ReadData();
    const { site } = auth.authProvider.GetToken && auth.authProvider.GetAuthenticatedStaff();
    const title = "Patient Activity";

    function scrollTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    // query
    const { loading, data, refetch } = useQuery(LIST, {
        variables: {
            id: patient && patient.lastAdmission,
            site: site && site.id,
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
        notifyOnNetworkStatusChange: true,
    });
    //  mutation

    // set taken
    const [postTakenFunc, { loading: sLoading }] = useMutation(SET_TAKEN, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            const { message } = d.SetActivityTaken;
            toast.success(message);
            sendNotification(message, ACTION_TYPE.UPDATE, EVENT_TARGET.ACTIVITY);
        },
    });

    // New
    const [PostCreateFunc, { loading: cLoading }] = useMutation(CREATE, {
        onCompleted: (d) => {
            const { message } = d.NewPatientActivity;
            toast.success(message);
            sendNotification(message, ACTION_TYPE.CREATE, EVENT_TARGET.ACTIVITY);
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });

    if (patient && !patient.lastAdmission)
        return (
            <div className="text-center">
                <h2 className="text-pink">Feature can only be used for in-patient only!</h2>
            </div>
        );

    EventEmitter.subscribe(EVENT_TARGET.ACTIVITY, () => refetch());

    return (
        <>
            <Helmet>
                <title>
                    {title} | {appName}
                </title>
            </Helmet>

            <div className="row">
                <div className="col-md-12">
                    <LoadingSpinner loading={loading || cLoading || sLoading} />
                </div>
                {newItem && !activeItem && (
                    <>
                        <div className="col-md-12">
                            <button
                                onClick={() => {
                                    setNewItem(false);
                                    setActiveItem(null);
                                    scrollTop();
                                }}
                                title="Back"
                                className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                            >
                                <i className="material-icons text-primary">keyboard_backspace</i>
                            </button>
                            New Patient Activity
                        </div>

                        <div className="col-md-12 col-xs-12 fade-in">
                            <NewActivity
                                categories={data && data.GetNoteCategories.docs}
                                onCancel={() => {
                                    setNewItem(false);
                                    setActiveItem(null);
                                    scrollTop();
                                }}
                                onSubmit={async (item) => {
                                    await PostCreateFunc({
                                        variables: {
                                            model: {
                                                ...item,
                                                admission: patient.lastAdmission,
                                            },
                                        },
                                    });
                                    setTimeout(() => {
                                        setNewItem(false);
                                        setActiveItem(null);
                                        scrollTop();
                                    }, 500);
                                }}
                            />
                            <LoadingSpinner loading={sLoading} bar={true} />
                        </div>
                    </>
                )}
                {!newItem && !activeItem && (
                    <>
                        {/* <div className="col-md-12 fade-in">
                            <h2>Patient Activities</h2>
                        </div> */}
                        <div className="col-md-12">
                            {!loading && (
                                <PatientActivityListing
                                    items={data && data.GetPatientActivities.docs}
                                    onTake={async (item) => {
                                        const { id, observation } = item;
                                        setItem(id);
                                        await postTakenFunc({
                                            variables: {
                                                id,
                                                observation,
                                            },
                                        });
                                        setTimeout(() => {
                                            setNewItem(false);
                                            setActiveItem(null);
                                            scrollTop();
                                        }, 500);
                                    }}
                                />
                            )}
                        </div>
                    </>
                )}
            </div>

            {!newItem && (
                <div className="fade-in">
                    <FabButton
                        title="new Activity"
                        onClick={() => {
                            scrollTop();
                            setNewItem(true);
                            setActiveItem(null);
                        }}
                    />
                </div>
            )}
        </>
    );
}

export default PatientActivity;
